export const SUPPLIER_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  supplierName: 'supplierName',
  supplierCode: 'supplierCode',
  shippingSitesCount: 'shippingSitesCount',
  primaryContact: 'primaryContact',
  lastUpdated: 'lastUpdated',
});

// Sort/search send Prisma column names, not the response's camelCase JSON keys.
export const SUPPLIER_SORT_FIELDS = Object.freeze({
  [SUPPLIER_COLUMNS.supplierName]: 'companyname',
  [SUPPLIER_COLUMNS.supplierCode]: 'supplier_id',
  [SUPPLIER_COLUMNS.lastUpdated]: 'updated_at',
});

export const SUPPLIER_SEARCH_IN = Object.freeze(['companyname', 'supplier_id']);

export const SUPPLIER_FIELDS = Object.freeze({
  organizationName: 'organizationName',
  supplierId: 'supplierId',
  primaryEmail: 'primaryEmail',
  primaryContactName: 'primaryContactName',
});

export const SHIPPING_SITE_FIELDS = Object.freeze({
  shippingFrom: 'shippingFrom',
  siteManagerName: 'siteManagerName',
  siteManagerEmail: 'siteManagerEmail',
});

export const ORGANIZATION_NAME_MAX_LENGTH = 80;
export const MAX_SHIPPING_SITES = 5;

// Flat `sites.<key>.<field>` names, so each site field is a real <Field> with a stable key.
export const SHIPPING_SITE_KEYS_FIELD = 'shippingSiteKeys';
export const FIRST_SHIPPING_SITE_KEY = '1';

export const shippingSiteNamePrefix = (siteKey) => `sites.${siteKey}.`;

export const shippingSiteFieldName = (siteKey, field) =>
  `${shippingSiteNamePrefix(siteKey)}${field}`;

export const emptyShippingSiteValues = (siteKey) =>
  Object.fromEntries(
    Object.values(SHIPPING_SITE_FIELDS).map((field) => [shippingSiteFieldName(siteKey, field), '']),
  );

// The next unused key, so a removed card never frees a key a later one would reuse.
export const nextShippingSiteKey = (siteKeys) =>
  String(siteKeys.reduce((max, key) => Math.max(max, Number(key) || 0), 0) + 1);

export const EMPTY_SUPPLIER_FORM = Object.freeze({
  [SUPPLIER_FIELDS.organizationName]: '',
  [SUPPLIER_FIELDS.supplierId]: '',
  [SUPPLIER_FIELDS.primaryEmail]: '',
  [SUPPLIER_FIELDS.primaryContactName]: '',
  [SHIPPING_SITE_KEYS_FIELD]: [FIRST_SHIPPING_SITE_KEY],
  ...emptyShippingSiteValues(FIRST_SHIPPING_SITE_KEY),
});
